import { getHeaders, SubmissionURL } from './config';
import { checkStatus, getData, getText } from './normalizer';
import { GLRatingRequest, GLRatingResponse } from 'types/generalLiability.type';

export async function getRaaSJSON(ratingRequest: GLRatingRequest): Promise<GLRatingResponse> {
    return fetch(`${SubmissionURL}/general_liability/raas`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(ratingRequest),
    })
        .then(checkStatus)
        .then(getData);
}

export async function getRaaSHTML(ratingRequest: GLRatingRequest): Promise<string> {
    return fetch(`${SubmissionURL}/general_liability/raas`, {
        method: 'POST',
        headers: getHeaders({ Accept: 'text/html' }),
        body: JSON.stringify(ratingRequest),
    })
        .then(checkStatus)
        .then(getText);
}
